import React from 'react';

const PriceProgressBar = ({ timeRange, min, max, close, variation, volume }) => {
  const percent = ((close - min) / (max - min)) * 100;
  return (
    <div className="w-full mt-4 mb-8 max-w-xs">
      {/* Display for close price and variation */}
      <div className="flex justify-start items-center mb-2">
        <span className="text-xl font-mono mr-2 font-bold">${close.toFixed(5)}</span>  {/* Close price with large monospace font */}
        <span className="text-sm font-semibold" style={{ color: variation >= 0 ? 'green' : 'red' }}>
          {variation >= 0 ? `+${variation.toFixed(2)}%` : `${variation.toFixed(2)}%`}  {/* Variation, colored based on positive or negative */}
        </span>
      </div>
      {/* Progress bar container */}
      <div className="bg-gray-200 rounded-full h-4 overflow-hidden">
        <div
          className="h-full"
          style={{
            width: `${percent}%`,
            background: 'linear-gradient(to right, blue, red)'
          }}
        ></div>
      </div>
      {/* Labels for min, timeRange, and max */}
      <div className="flex justify-between text-xs font-bold mt-2">
        <span>${min}</span>
        <span>${volume.toLocaleString('en-US', { maximumFractionDigits: 0 })}</span>
        <span>${max}</span>
      </div>
    </div>
  );
};

export default PriceProgressBar;

